import apiClient from 'enrollment-platform/api/enrollment-platform-client/api-client'
import {
  FundingInvoiceDetailDto,
  FundingInvoiceListResponseDto,
  FundingInvoiceVersionsResponseDto,
  GenerateAllInvoicesDto,
  GenerateAllResultDto,
  GenerateInvoiceDto,
  GenerateResultDto,
  GetGeneratedInvoicesRequestDto,
} from './dto/generated-invoice.dto'

const BASE_PATH = '/funding-invoice'

export const getGeneratedInvoices = async (
  params: GetGeneratedInvoicesRequestDto
): Promise<FundingInvoiceListResponseDto> => {
  const response = await apiClient.get<FundingInvoiceListResponseDto>(
    `${BASE_PATH}/invoices`,
    { params }
  )
  return response.data
}

export const getGeneratedInvoiceDetail = async (
  id: string
): Promise<FundingInvoiceDetailDto> => {
  const response = await apiClient.get<FundingInvoiceDetailDto>(
    `${BASE_PATH}/invoices/${id}`
  )
  return response.data
}

export const getGeneratedInvoiceVersions = async (
  id: string
): Promise<FundingInvoiceVersionsResponseDto> => {
  const response = await apiClient.get<FundingInvoiceVersionsResponseDto>(
    `${BASE_PATH}/invoices/${id}/versions`
  )
  return response.data
}

export const generateInvoice = async (
  payload: GenerateInvoiceDto
): Promise<GenerateResultDto> => {
  const response = await apiClient.post<GenerateResultDto>(
    `${BASE_PATH}/generate`,
    payload
  )
  return response.data
}

export const generateAllInvoices = async (
  payload: GenerateAllInvoicesDto
): Promise<GenerateAllResultDto> => {
  const response = await apiClient.post<GenerateAllResultDto>(
    `${BASE_PATH}/generate-all`,
    payload
  )
  return response.data
}
